export const GIFS = {
    ASTRO_GIF : require("./res/Astronova.gif"),
    ASTRO_GIF2 : require("./res/64-color.gif"),
    CHEST_TREASURE : require("./res/chest_1.gif"),
    BRONZE: require("./res/BRONZE.gif"),
    SILVER: require("./res/SILVER.gif"),
    GOLD: require("./res/GOLD.gif"),
    EMERALD: require("./res/EMERALD.gif"),
}